module.exports = __webpack_public_path__ + "static/media/carsguide.c92f1e97.png";